import Guid from "_shared/guids/guid";
import { useGetFeeSchedulesForTeamQuery } from "marketplace/teams/fee-schedules/_api/fee-schedule-api";
import { getFeeSchedulesForTeam } from "marketplace/teams/fee-schedules/_stores/fee-schedule-redux-slice";
import FeeSchedule from "marketplace/teams/fee-schedules/fee-schedule";
import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * The fee schedules a marketplace team publishes that have rates in them (#4920).
 *
 * A schedule with no rates would apply nothing, so it is left out. The list is empty while the
 * schedules first load, and when the team publishes no rates. After a failed load the store still
 * holds what the last successful load returned, so a caller that offers them checks `schedulesQuery`.
 */
export default function usePublishedFeeSchedules(marketplaceTeamId: Guid) {
  const schedulesQuery = useGetFeeSchedulesForTeamQuery({ teamId: marketplaceTeamId.value });
  const feeSchedulesJson = useSelector(getFeeSchedulesForTeam(marketplaceTeamId));
  const schedules: FeeSchedule[] = useMemo(
    () =>
      feeSchedulesJson
        ? FeeSchedule.fromJSONArray(feeSchedulesJson).filter((schedule) => schedule.categories.length > 0)
        : [],
    [feeSchedulesJson],
  );  return { schedules, schedulesQuery };
}
